module.exports = __webpack_public_path__ + "static/img/8.0725225.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/eng/8.png
// module id = 52dc
// module chunks = 0